__turbopack_context__.v({
  "mask": "InternetTime-module__yJS8QW__mask",
});
